import React from "react";

function Play({clasess}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="16"
      fill="none"
      viewBox="0 0 12 16"
      className={clasess}
    >
      <path
        d="M11.436 6.983l-9.6-6A1.2 1.2 0 000 2v12a1.2 1.2 0 001.836 1.018l9.6-6a1.201 1.201 0 000-2.035z"
      ></path>
    </svg>
  );
}

export default Play;
